export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const NOT_ENTER_USER = 'NOT_ENTER_USER';
export const SET_USER_LOGOUT = 'SET_USER_LOGOUT';
export const NOT_FIND_USER = 'NOT_FIND_USER';
export const SET_PERMISSION = 'SET_PERMISSION';
export const SET_ACTUAL_STATUS = 'SET_ACTUAL_STATUS';
export const PUSH_ACTUAL_STATUS = 'PUSH_ACTUAL_STATUS';
export const SET_BEACON_STATUS = 'SET_BEACON_STATUS';
export const PUSH_BEACON_STATUS = 'PUSH_BEACON_STATUS';
export const SET_IS_OPEN_GLOBAL_SIDEBAR = 'SET_IS_OPEN_GLOBAL_SIDEBAR';
export const SET_BODY_GLOBAL_SIDEBAR = 'SET_BODY_GLOBAL_SIDEBAR';
export const SET_UNREAD_NOTIFICATIONS_COUNT = 'SET_UNREAD_NOTIFICATIONS_COUNT';
export const SET_CURRENT_ACCOUNT_DATA = 'SET_CURRENT_ACCOUNT_DATA';
